import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5526427c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 4,
  class: "save-successful"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 5,
  class: "detailsRow d-flex"
}
const _hoisted_9 = { class: "detailsCol" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsRow = _resolveComponent("DetailsRow")!
  const _component_Select = _resolveComponent("Select")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DetailsRow, {
      caption: "person.personalId",
      details: _ctx.person.personalId
    }, null, 8, ["details"]),
    _createVNode(_component_DetailsRow, {
      caption: "person.name",
      details: `${_ctx.person.firstName} ${_ctx.person.lastName}`
    }, null, 8, ["details"]),
    (_ctx.person.address)
      ? (_openBlock(), _createBlock(_component_DetailsRow, {
          key: 0,
          caption: "person.address",
          details: `${_ctx.person.address}, ${_ctx.person.postcode}, ${_ctx.person.city}`
        }, null, 8, ["details"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DetailsRow, {
      caption: "person.email",
      details: _ctx.person.email
    }, null, 8, ["details"]),
    _createVNode(_component_DetailsRow, {
      caption: "person.telephoneNumber",
      details: _ctx.person.telephoneNumber
    }, null, 8, ["details"]),
    (_ctx.showCourses)
      ? (_openBlock(), _createBlock(_component_DetailsRow, {
          key: 1,
          caption: "shared.courses",
          details: _ctx.mappedCourses,
          detailsAreList: true,
          detailsAreHtml: true
        }, null, 8, ["details"]))
      : _createCommentVNode("", true),
    (_ctx.showCoordinator)
      ? (_openBlock(), _createBlock(_component_DetailsRow, {
          key: 2,
          caption: "person.coordinator",
          required: _ctx.requiredCoordinator
        }, {
          default: _withCtx(() => [
            (_ctx.editEnable || _ctx.editCoordinator)
              ? (_openBlock(), _createBlock(_component_Select, {
                  key: 0,
                  id: "coordinator",
                  options: _ctx.coordinatorIds,
                  value: _ctx.person.coordinatorId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.person.coordinatorId) = $event)),
                  placeholder: `- ${_ctx.$t('shared.choose')} -`,
                  isNumber: true
                }, {
                  default: _withCtx((data) => [
                    _createTextVNode(_toDisplayString(_ctx.getCoordinatorName(data.value)), 1)
                  ]),
                  _: 1
                }, 8, ["options", "value", "placeholder"]))
              : (_ctx.coordinator)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.coordinator.name), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("student-details.no-coordinator")), 1))
          ]),
          _: 1
        }, 8, ["required"]))
      : _createCommentVNode("", true),
    (
      this.person.hasOwnProperty('grantedSupportDate') &&
      this.person.grantedSupportDate !== null
    )
      ? (_openBlock(), _createBlock(_component_DetailsRow, {
          key: 3,
          caption: "person.grantedSupportDate"
        }, {
          default: _withCtx(() => [
            (_ctx.editEnable)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createVNode(_component_DatePicker, {
                    value: _ctx.person.grantedSupportDate,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.person.grantedSupportDate) = $event)),
                    required: true,
                    clearable: false
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.editEnable)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.formatedDate), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showSuccessMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t("shared.saveSuccessful")) + " ", 1),
          (_ctx.showSuccessMsg)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-label": "Close",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSuccessMsg = null))
              }, _hoisted_7))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.showEditButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.editEnable)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  title: _ctx.$t('student-details.edit-btn-tooltip'),
                  id: "editBtn",
                  type: "button",
                  class: "btn btn-outline-primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.edit()))
                }, _toDisplayString(_ctx.$t("shared.edit")), 9, _hoisted_10))
              : _createCommentVNode("", true),
            (_ctx.editEnable || _ctx.editCoordinatorEnable)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  id: "cancelBtn",
                  type: "button",
                  class: "btn btn-outline-primary mr-2",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancel()))
                }, _toDisplayString(_ctx.$t("shared.cancel")), 1))
              : _createCommentVNode("", true),
            (_ctx.editEnable || _ctx.editCoordinatorEnable)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  "background-color": "btn btn-primary",
                  id: "saveBtn",
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save())),
                  disabled: _ctx.saveBtnDisabled
                }, _toDisplayString(_ctx.$t("shared.save")), 9, _hoisted_11))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}